<img [src]="src"
     (error)="replaceSrc()"
     [alt]="title"
     [title]='title'
     [attr.height]="height"
     [attr.width]="width">
